import {
	Player,
	WithdrawPlayerMutationParams,
	CashdeskTransaction,
	createWithdrawPlayerMutation,
} from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type ResetPlayerBalanceModel = ConfirmModalModel<
	Player,
	WithdrawPlayerMutationParams,
	CashdeskTransaction
>;

export const createResetPlayerBalanceModel = (): ResetPlayerBalanceModel => {
	const withdrawPlayerMutation = createWithdrawPlayerMutation();

	const model = createConfirmModalModel<Player, WithdrawPlayerMutationParams, CashdeskTransaction>({
		modalData: declareModalData<Player>(),
		mutation: withdrawPlayerMutation,
		mapModalData: ({ id, balance }) => ({ id, amount: balance }),
		successMessageKey: 'reset-player-balance.success',
	});

	return model;
};
